var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDoorBackBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1274_25333",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1274_25333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 18C3.09722 18 2.89931 17.9201 2.73958 17.7604C2.57986 17.6007 2.5 17.4028 2.5 17.1667C2.5 16.9306 2.57986 16.7326 2.73958 16.5729C2.89931 16.4132 3.09722 16.3333 3.33333 16.3333H4.16667V4.66667C4.16667 4.20833 4.32986 3.81597 4.65625 3.48958C4.98264 3.16319 5.375 3 5.83333 3H14.1667C14.625 3 15.0174 3.16319 15.3438 3.48958C15.6701 3.81597 15.8333 4.20833 15.8333 4.66667V16.3333H16.6667C16.9028 16.3333 17.1007 16.4132 17.2604 16.5729C17.4201 16.7326 17.5 16.9306 17.5 17.1667C17.5 17.4028 17.4201 17.6007 17.2604 17.7604C17.1007 17.9201 16.9028 18 16.6667 18H3.33333ZM8.33333 11.3333C8.56944 11.3333 8.76736 11.2535 8.92708 11.0938C9.08681 10.934 9.16667 10.7361 9.16667 10.5C9.16667 10.2639 9.08681 10.066 8.92708 9.90625C8.76736 9.74653 8.56944 9.66667 8.33333 9.66667C8.09722 9.66667 7.89931 9.74653 7.73958 9.90625C7.57986 10.066 7.5 10.2639 7.5 10.5C7.5 10.7361 7.57986 10.934 7.73958 11.0938C7.89931 11.2535 8.09722 11.3333 8.33333 11.3333Z",
    fill: "#1B4B86"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoorBackBlue);
export default __webpack_public_path__ + "static/media/icon_door_back_blue.eabf201934cc2932402b154b59911d3f.svg";
export { ForwardRef as ReactComponent };